import { IDestroyOptions, TextStyle, Ticker } from "pixi.js";
import { AdaptiveText } from "ui-pixijs";
import { LocalizationKey } from "../../localization/Localization";
import { LocalizationModel } from "../models/LocalizationModel";

export class TypedText extends AdaptiveText {
    protected textUpdateFn?: (delta: number) => void;
    protected cancelled: boolean = false;
    public constructor(
        protected localizationModel: LocalizationModel,
        protected textKey: LocalizationKey,
        style: TextStyle,
        autoFitWidth: number,
        autoFitHeight: number,
        protected xOffset: number = 0
    ) {
        super("", style, autoFitWidth, autoFitHeight);
    }

    public animateText(duration: number = 500): Promise<void> {
        return new Promise((resolve) => {
            if (this.textUpdateFn) Ticker.shared.remove(this.textUpdateFn);

            const fullText = this.localizationModel.getText(this.textKey);
            const totalLetters = fullText.length;
            let elapsed = 0;

            this.textUpdateFn = (_dt: number) => {
                if (this.destroyed || this.cancelled) {
                    Ticker.shared.remove(this.textUpdateFn!);
                    this.textUpdateFn = undefined;
                    return resolve();
                }
                elapsed += Ticker.shared.elapsedMS;
                const t = Math.min(elapsed / duration, 1);

                const lettersToShow = Math.floor(totalLetters * t);
                this.text = fullText.substring(0, lettersToShow);
                this.position.x = (this.parent.width - this.width) * 0.5 + this.xOffset;

                if (t >= 1) {
                    Ticker.shared.remove(this.textUpdateFn!);
                    this.textUpdateFn = undefined;
                    resolve();
                }
            };

            Ticker.shared.add(this.textUpdateFn);
        });
    }

    public cancelAnimation(): void {
        this.cancelled = true;
        if (this.textUpdateFn) {
            Ticker.shared.remove(this.textUpdateFn);
            this.textUpdateFn = undefined;
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.cancelAnimation();
        super.destroy(options);
    }
}